import React, { useMemo, useState } from "react";
import "./Mxh.css";

const demoItems = [
  { id: 1, type: "video", thumb: "/m1.jpg", href: "#" },
  { id: 2, type: "video", thumb: "/m2.jpg", href: "#" },
  { id: 3, type: "image", thumb: "/m3.jpg", href: "#" },
  { id: 4, type: "image", thumb: "/m4.jpg", href: "#" },
  { id: 5, type: "image", thumb: "/m5.jpg", href: "#" },
];

export default function Mxh({
  brand = {
    logo: "/images/siam-logo.png",
    name: "siamtravelvn",
    bio: "Công ty du lịch và lữ hành tại Việt Nam",
    profileUrl: "https://www.instagram.com/siamtravelvn/",
  },
  items = demoItems,
  initialCount = 5,
  step = 5,
}) {
  const [visible, setVisible] = useState(initialCount);

  const visibleItems = useMemo(() => items.slice(0, visible), [items, visible]);
  const canLoadMore = visible < items.length;

  return (
    <section className="ig-wrap" aria-label="Instagram Section">
      <div className="ig-inner">
        {/* Header */}
        <div className="ig-head">
          <img className="ig-logo" src={brand.logo} alt={brand.name} />
          <div className="ig-meta">
            <a className="ig-name" href={brand.profileUrl} target="_blank" rel="noreferrer">
              {brand.name}
            </a>
            <div className="ig-bio">{brand.bio}</div>
          </div>
        </div>

        {/* Grid */}
        <div className="ig-grid">
          {visibleItems.map((it) => (
            <a
              key={it.id}
              className="ig-item"
              href={it.href || brand.profileUrl}
              target="_blank"
              rel="noreferrer"
              aria-label="Open Instagram post"
            >
              <img className="ig-thumb" src={it.thumb} alt="" loading="lazy" />
              {it.type === "video" && (
                <span className="ig-play" aria-hidden="true">
                  ▶
                </span>
              )}
            </a>
          ))}
        </div>

        {/* Actions */}
        <div className="ig-actions">
          <button
            className="ig-btn ig-btn-dark"
            type="button"
            onClick={() => setVisible((v) => Math.min(v + step, items.length))}
            disabled={!canLoadMore}
          >
            Tải thêm
          </button>

          <a className="ig-btn ig-btn-blue" href={brand.profileUrl} target="_blank" rel="noreferrer">
            <span className="ig-igIcon" aria-hidden="true">◉</span>
            Theo dõi trên Instagram
          </a>
        </div>
      </div>
    </section>
  );
}